import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TwoStepModalComponent } from './two-step-modal.component';

@NgModule({
    declarations: [
        TwoStepModalComponent
    ],
    imports: [
        RouterModule,
        FuseSharedModule
    ],
    exports: [
        TwoStepModalComponent
    ],
    entryComponents:[
        TwoStepModalComponent
    ]
})
export class TwoStepModalModule {
}
